// Single source of truth for design-size presets.
// Add a new design type by appending to DESIGN_SIZES — no UI changes required.

export const CATEGORIES = [
  'Popular Sizes',
  'Social Media',
  'Marketing',
  'Print & Documents',
  'Business',
  'Events',
  'Education',
];

export const DESIGN_SIZES = [
  // Popular Sizes
  { id: 'pop-instagram-post',     name: 'Instagram Post',     category: 'Popular Sizes', width: 1080, height: 1080, keywords: ['social', 'square', 'ig'] },
  { id: 'pop-instagram-story',    name: 'Instagram Story',    category: 'Popular Sizes', width: 1080, height: 1920, keywords: ['social', 'vertical', 'ig'] },
  { id: 'pop-facebook-post',      name: 'Facebook Post',      category: 'Popular Sizes', width: 1200, height: 630,  keywords: ['social', 'fb'] },
  { id: 'pop-youtube-thumbnail',  name: 'YouTube Thumbnail',  category: 'Popular Sizes', width: 1280, height: 720,  keywords: ['video', 'yt', 'thumb'] },
  { id: 'pop-youtube-banner',     name: 'YouTube Banner',     category: 'Popular Sizes', width: 2560, height: 1440, keywords: ['video', 'yt', 'channel art'] },
  { id: 'pop-linkedin-post',      name: 'LinkedIn Post',      category: 'Popular Sizes', width: 1200, height: 1200, keywords: ['social', 'professional', 'square'] },
  { id: 'pop-presentation',       name: 'Presentation',       category: 'Popular Sizes', width: 1920, height: 1080, keywords: ['slides', 'deck', '16:9'] },

  // Social Media
  { id: 'sm-instagram-post',  name: 'Instagram Post',  category: 'Social Media', width: 1080, height: 1080, keywords: ['ig', 'square', 'photo'] },
  { id: 'sm-instagram-story', name: 'Instagram Story', category: 'Social Media', width: 1080, height: 1920, keywords: ['ig', 'vertical'] },
  { id: 'sm-instagram-reel',  name: 'Instagram Reel',  category: 'Social Media', width: 1080, height: 1920, keywords: ['ig', 'video', 'vertical'] },
  { id: 'sm-facebook-post',   name: 'Facebook Post',   category: 'Social Media', width: 1200, height: 630,  keywords: ['fb', 'feed'] },
  { id: 'sm-facebook-cover',  name: 'Facebook Cover',  category: 'Social Media', width: 820,  height: 312,  keywords: ['fb', 'header'] },
  { id: 'sm-linkedin-post',   name: 'LinkedIn Post',   category: 'Social Media', width: 1200, height: 1200, keywords: ['professional', 'square'] },
  { id: 'sm-linkedin-banner', name: 'LinkedIn Banner', category: 'Social Media', width: 1584, height: 396,  keywords: ['professional', 'header', 'cover'] },
  { id: 'sm-twitter-post',    name: 'Twitter Post',    category: 'Social Media', width: 1200, height: 675,  keywords: ['x', 'tweet'] },
  { id: 'sm-twitter-header',  name: 'Twitter Header',  category: 'Social Media', width: 1500, height: 500,  keywords: ['x', 'cover'] },
  { id: 'sm-youtube-thumb',   name: 'YouTube Thumbnail', category: 'Social Media', width: 1280, height: 720, keywords: ['video', 'yt'] },
  { id: 'sm-youtube-banner',  name: 'YouTube Banner',  category: 'Social Media', width: 2560, height: 1440, keywords: ['video', 'yt', 'channel art'] },
  { id: 'sm-tiktok-video',    name: 'TikTok Video',    category: 'Social Media', width: 1080, height: 1920, keywords: ['short', 'vertical', 'video'] },
  { id: 'sm-pinterest-pin',   name: 'Pinterest Pin',   category: 'Social Media', width: 1000, height: 1500, keywords: ['vertical', 'pin'] },

  // Marketing
  { id: 'mk-flyer',         name: 'Flyer',         category: 'Marketing', width: 1080, height: 1350, keywords: ['print', 'promo', 'leaflet'] },
  { id: 'mk-poster',        name: 'Poster',        category: 'Marketing', width: 1080, height: 1920, keywords: ['print', 'promo', 'wall'] },
  { id: 'mk-brochure',      name: 'Brochure',      category: 'Marketing', width: 794,  height: 1123, displayLabel: 'A4', keywords: ['print', 'fold', 'a4'] },
  { id: 'mk-banner',        name: 'Banner',        category: 'Marketing', width: 1200, height: 300,  keywords: ['web', 'header'] },
  { id: 'mk-web-banner',    name: 'Web Banner',    category: 'Marketing', width: 1500, height: 500,  keywords: ['web', 'hero'] },
  { id: 'mk-email-header',  name: 'Email Header',  category: 'Marketing', width: 600,  height: 200,  keywords: ['newsletter', 'mail'] },
  { id: 'mk-newsletter',    name: 'Newsletter',    category: 'Marketing', width: 600,  height: 1200, keywords: ['mail', 'email'] },

  // Print & Documents
  { id: 'pd-a4-portrait',  name: 'A4 Portrait',   category: 'Print & Documents', width: 794,  height: 1123, displayLabel: 'A4', keywords: ['document', 'paper'] },
  { id: 'pd-a4-landscape', name: 'A4 Landscape',  category: 'Print & Documents', width: 1123, height: 794,  displayLabel: 'A4 Landscape', keywords: ['document', 'horizontal'] },
  { id: 'pd-letter',       name: 'US Letter',     category: 'Print & Documents', width: 816,  height: 1056, displayLabel: 'Letter', keywords: ['document', 'paper', 'us'] },
  { id: 'pd-legal',        name: 'US Legal',      category: 'Print & Documents', width: 816,  height: 1344, displayLabel: 'Legal', keywords: ['document', 'long'] },
  { id: 'pd-a3',           name: 'A3',            category: 'Print & Documents', width: 1123, height: 1587, displayLabel: 'A3', keywords: ['large', 'paper'] },
  { id: 'pd-a5',           name: 'A5',            category: 'Print & Documents', width: 559,  height: 794,  displayLabel: 'A5', keywords: ['small', 'paper'] },
  { id: 'pd-resume',       name: 'Resume',        category: 'Print & Documents', width: 794,  height: 1123, displayLabel: 'A4', keywords: ['cv', 'job', 'a4'] },

  // Business
  { id: 'bz-business-card', name: 'Business Card', category: 'Business', width: 1050, height: 600,  keywords: ['print', 'card', '3.5x2'] },
  { id: 'bz-letterhead',    name: 'Letterhead',    category: 'Business', width: 794,  height: 1123, displayLabel: 'A4', keywords: ['stationery', 'a4'] },
  { id: 'bz-invoice',       name: 'Invoice',       category: 'Business', width: 816,  height: 1056, displayLabel: 'Letter', keywords: ['bill', 'document'] },
  { id: 'bz-id-card',       name: 'ID Card',       category: 'Business', width: 1050, height: 675,  keywords: ['badge', 'employee'] },
  { id: 'bz-logo',          name: 'Logo',          category: 'Business', width: 1024, height: 1024, keywords: ['brand', 'square'] },

  // Events
  { id: 'ev-invitation',     name: 'Invitation Card', category: 'Events', width: 1080, height: 1350, keywords: ['party', 'card'] },
  { id: 'ev-save-the-date',  name: 'Save the Date',   category: 'Events', width: 1080, height: 1080, keywords: ['wedding', 'card'] },
  { id: 'ev-greeting-card',  name: 'Greeting Card',   category: 'Events', width: 1500, height: 1200, keywords: ['holiday', 'card'] },
  { id: 'ev-ticket',         name: 'Ticket',          category: 'Events', width: 1800, height: 600,  keywords: ['admission', 'pass'] },
  { id: 'ev-certificate',    name: 'Certificate',     category: 'Events', width: 1123, height: 794,  displayLabel: 'A4 Landscape', keywords: ['award', 'diploma'] },
  { id: 'ev-event-banner',   name: 'Event Banner',    category: 'Events', width: 1920, height: 1080, keywords: ['promo', 'stage'] },

  // Education
  { id: 'ed-worksheet',   name: 'Worksheet',    category: 'Education', width: 794,  height: 1123, displayLabel: 'A4', keywords: ['school', 'class', 'a4'] },
  { id: 'ed-lesson-plan', name: 'Lesson Plan',  category: 'Education', width: 794,  height: 1123, displayLabel: 'A4', keywords: ['teacher', 'class', 'a4'] },
  { id: 'ed-infographic', name: 'Infographic',  category: 'Education', width: 800,  height: 2000, keywords: ['chart', 'data', 'long'] },
  { id: 'ed-flashcard',   name: 'Flashcard',    category: 'Education', width: 1050, height: 600,  keywords: ['study', 'memorize'] },
  { id: 'ed-whiteboard',  name: 'Whiteboard',   category: 'Education', width: 1600, height: 900,  keywords: ['brainstorm', 'collab'] },
];

// Cards shown above the categorized lists. Order matters; 'custom' is a special card.
export const QUICK_START_IDS = [
  'pop-instagram-post',
  'pop-instagram-story',
  'pop-facebook-post',
  'pop-youtube-thumbnail',
  'mk-flyer',
  'mk-poster',
  'bz-business-card',
  'pop-presentation',
  'custom', // sentinel — handled specially by the modal
];

const UNIT_TO_PX = {
  px: 1,
  in: 96,
  mm: 3.7795275591,
};

export function convertToPx(value, unit) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return 0;
  const factor = UNIT_TO_PX[unit] || 1;
  return Math.round(n * factor);
}

export function findById(id) {
  return DESIGN_SIZES.find((d) => d.id === id) || null;
}

export function getQuickStart() {
  return QUICK_START_IDS.map((id) => {
    if (id === 'custom') {
      return { id: 'custom', name: 'Custom Size', category: 'Custom Size', isCustom: true };
    }
    return findById(id);
  }).filter(Boolean);
}

export function byCategory() {
  const map = new Map();
  for (const cat of CATEGORIES) map.set(cat, []);
  for (const size of DESIGN_SIZES) {
    if (!map.has(size.category)) map.set(size.category, []);
    map.get(size.category).push(size);
  }
  return map;
}

// Case-insensitive substring match across name, category, dimensions, and keywords.
export function searchSizes(query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return DESIGN_SIZES;
  return DESIGN_SIZES.filter((size) => {
    if (size.name.toLowerCase().includes(q)) return true;
    if (size.category.toLowerCase().includes(q)) return true;
    const w = String(size.width);
    const h = String(size.height);
    if (w.includes(q) || h.includes(q)) return true;
    const dims = [`${w}x${h}`, `${w} x ${h}`, `${w}×${h}`, `${w} × ${h}`];
    if (dims.some((d) => d.includes(q))) return true;
    if (size.keywords && size.keywords.some((k) => k.toLowerCase().includes(q))) return true;
    return false;
  });
}

export function formatDimensions(size) {
  if (size.displayLabel) return size.displayLabel;
  return `${size.width} × ${size.height}`;
}
